import Splide from '@splidejs/splide';
import '@splidejs/splide/css';
document.addEventListener('DOMContentLoaded', () => {
    // Cards slider
    new Splide('.abi-champains-carousel', {
        arrows: false,
        pagination: true,
        //type: 'loop',
        gap: 47,
        perPage: 3,
        padding: '0%',
        breakpoints: {
            767: {
                gap: 10,
                perPage: 1,
                padding: '20%',
            },
        }
    }).mount();
});
